import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("vs_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const api = {
  createLead: (payload) => client.post("/leads", payload).then((r) => r.data),
  login: (email, password) =>
    client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  listLeads: (status) =>
    client
      .get("/admin/leads", { params: status ? { status } : {} })
      .then((r) => r.data),
  updateLeadStatus: (id, status) =>
    client.patch(`/admin/leads/${id}`, { status }).then((r) => r.data),
  deleteLead: (id) => client.delete(`/admin/leads/${id}`).then((r) => r.data),
  stats: () => client.get("/admin/stats").then((r) => r.data),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
